import Siema from 'siema'

const logoSliders = [...document.querySelectorAll('.js-logoSlider')]

if (logoSliders.length) {
    logoSliders.forEach(function applyLogoSlider (logoSlider) {
        const logoSliderElement = logoSlider.querySelector('.js-logoSliderTray')
        const windowWidth = window.outerWidth
        let slidesPer = 3

        if (windowWidth > 800) {
            slidesPer = 5
        } else if (windowWidth < 800 && windowWidth > 450) {
            slidesPer = 3
        } else {
            slidesPer = 2
        }

        const logoSliderInstance = new Siema({
            selector: logoSliderElement,
            duration: 4000,
            loop: true,
            easing: 'linear',
            perPage: slidesPer,
        })

        logoSliderInstance.next(1)

        function continuousSlider () {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    logoSliderInstance.next(1)
                    continuousSlider()
                })
            }, 4000)
        }

        continuousSlider()
    })
}
